// extracted by mini-css-extract-plugin
export default {"title":"NoticeDetail_title__bev+v","dateTime":"NoticeDetail_dateTime__PqoyU","label":"NoticeDetail_label__syek+","text":"NoticeDetail_text__sxbIF"};